import api from '@/utils/api';

/**
 * Create company
 * @param {object} companyData - The company data
 * @returns {Promise}
 */
const createCompanyApi = (companyData) => api.post('/company', companyData);

export default createCompanyApi;
